import { render, staticRenderFns } from "./ActionSubmenu.vue?vue&type=template&id=9d258692&"
import script from "./ActionSubmenu.vue?vue&type=script&lang=js&"
export * from "./ActionSubmenu.vue?vue&type=script&lang=js&"
import style0 from "@/assets/styles/themes/default/actionsubmenu.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports